export const tournamentStatus = [
    {key:"Created", value: 0},
    {key:"Open", value: 1},
    {key:"Started", value: 2},
    {key:"Running", value: 3},
    {key:"Closed", value: 4},
];